import { FC } from "react";

import { IErrorComponent } from "../ErrorComponent";
import { ErrorTemplate } from "../blocks/ErrorTemplate";
import { FrontendTimeoutIcon } from "../../../icons/errors";

export const TIMEOUT_ERROR_MESSAGE = "Запрос занял"
  + " слишком много времени. Возможно, сервер временно перегружен";
export const TIMEOUT_ERROR_ADDITIONAL_MESSAGE = "Пожалуйста,"
  + " попробуйте обновить страницу через несколько секунд";

export const FrontendTimeoutError: FC<IErrorComponent> = (props) => {
  return (
    <ErrorTemplate
      {...props}
      icon={FrontendTimeoutIcon}
      message={TIMEOUT_ERROR_MESSAGE}
      additionalMessage={TIMEOUT_ERROR_ADDITIONAL_MESSAGE}
    />
  );
};
